import { render, staticRenderFns } from "./NewUserBusinessPermissionGroup.vue?vue&type=template&id=6a5c4fa8&scoped=true&"
import script from "./NewUserBusinessPermissionGroup.ts?vue&type=script&lang=ts&"
export * from "./NewUserBusinessPermissionGroup.ts?vue&type=script&lang=ts&"
import style0 from "./NewUserBusinessPermissionGroup.vue?vue&type=style&index=0&id=6a5c4fa8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5c4fa8",
  null
  
)

export default component.exports